'use strict';

angular.module('lmsApp').filter('territoryFilter', function () {
	return function (items, id) {
		var filtered = [];

		if (id === undefined || id === '') {
			return items;
		}

		angular.forEach(items, function (item) {
			if (item.region && item.region.id === id) {
				filtered.push(item);
			}
		});

		return filtered;
	};
});
